import { useMemo } from 'react';

/**
 * Custom hook for detox retreat booking table filters configuration
 * @returns {Array} Filter configuration for AdvancedTable
 */
export const useDetoxRetreatFilters = () => {
    return useMemo(() => [
        {
            id: 'customerName',
            label: 'Customer Name',
            type: 'text',
            placeholder: 'Search by customer name...',
        },
        {
            id: 'detoxRetreatName',
            label: 'Retreat Name',
            type: 'text',
            placeholder: 'Search by retreat name...',
        },
        {
            id: 'dateRange',
            label: 'Date Range',
            type: 'dateRange',
        },
    ], []);
};
